import { useChatOnlineUsers } from 'components/cutom-chat';

export const useOnlineUsers = () => {
  return useChatOnlineUsers();
};
